module.exports = __webpack_public_path__ + "static/shop-icon-mobile-ecf54c20ead4d376af89cf18edb49a24.png";